export class IFrameManager {
    private static iframe: HTMLIFrameElement;

    public static openInIFrame(url: string): void {
        this.iframe = document.createElement("iframe");
        this.iframe.setAttribute("src", url);
        this.iframe.setAttribute("allowfullscreen", "true");
        this.iframe.setAttribute("allowpaymentrequest", "true");
        this.iframe.allow = "payment *";
        this.iframe.id = "crossmint-embedded-checkout.iframe";
        this.iframe.role = "crossmint-embedded-checkout.iframe";

        this.iframe.width = `${window.innerWidth}px`;
        this.iframe.height = `${window.innerHeight}px`;
        this.iframe.style.position = "absolute";
        this.iframe.style.top = "0px";
        document.body.appendChild(this.iframe);
    }

    public static closeIFrame(): void {
        document.body.removeChild(this.iframe);
    }
}